export const SLA = (props) => {
  return (
    <section id='sla' style={{ padding: '100px 0', background: '#f8faff' }}>
      <div className='container'>

        {/* Section Header */}
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <p style={{
            color: '#5ca9fb', fontWeight: '700',
            fontSize: '12px', letterSpacing: '3px',
            textTransform: 'uppercase', margin: '0 0 16px',
          }}>
            — Service Level Agreement
          </p>
          <h2 style={{
            fontFamily: 'Raleway, sans-serif',
            fontSize: 'clamp(32px, 4vw, 52px)',
            fontWeight: '800', color: '#0f0f1a',
            lineHeight: '1.1', margin: '0 0 20px',
          }}>
            {props.data ? props.data.title : 'Our Service Commitments'}
          </h2>
          <p style={{
            color: '#888', fontSize: '16px',
            maxWidth: '520px', margin: '0 auto',
            lineHeight: '1.75',
          }}>
            {props.data ? props.data.subtitle : 'We back every engagement with clear, measurable service standards.'}
          </p>
        </div>

        {/* SLA Cards */}
        <div className='sla-grid'>
          {props.data && props.data.items
            ? props.data.items.map((item, i) => (
                <div
                  key={`sla-${i}`}
                  style={{
                    background: '#fff',
                    borderRadius: '20px',
                    padding: '40px 32px',
                    border: '1px solid #eef0ff',
                    textAlign: 'center',
                    transition: 'transform 0.25s, box-shadow 0.25s',
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.transform = 'translateY(-6px)';
                    e.currentTarget.style.boxShadow = '0 20px 50px rgba(92,169,251,0.12)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  {/* Icon */}
                  <div className='sla-icon' style={{
                    width: '56px', height: '56px',
                    borderRadius: '14px',
                    background: 'linear-gradient(135deg, rgba(92,169,251,0.1), rgba(99,114,255,0.1))',
                    border: '1px solid rgba(92,169,251,0.2)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    margin: '0 auto 20px',
                  }}>
                    <i className={item.icon} style={{ fontSize: '22px', color: '#5ca9fb' }}></i>
                  </div>

                  {/* Metric */}
                  <div style={{
                    fontFamily: 'Raleway, sans-serif',
                    fontSize: '32px', fontWeight: '800',
                    color: '#5ca9fb', lineHeight: 1,
                    marginBottom: '8px',
                  }}>
                    {item.metric}
                  </div>

                  {/* Label */}
                  <div style={{
                    fontSize: '14px', fontWeight: '700',
                    color: '#0f0f1a', textTransform: 'uppercase',
                    letterSpacing: '0.5px', marginBottom: '14px',
                  }}>
                    {item.label}
                  </div>

                  {/* Description */}
                  <p style={{
                    color: '#888', fontSize: '14px',
                    lineHeight: '1.7', margin: 0,
                  }}>
                    {item.text}
                  </p>
                </div>
              ))
            : 'Loading...'}
        </div>
      </div>

      <style>{`
        .sla-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 24px;
        }

        #sla .sla-icon i.fa {
          font-size: 22px !important;
          width: auto !important;
          height: auto !important;
          padding: 0 !important;
          border-radius: 0 !important;
          background: none !important;
          box-shadow: none !important;
          margin-bottom: 0 !important;
          color: inherit !important;
          display: inline !important;
          transition: none !important;
        }

        @media (max-width: 900px) {
          .sla-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }

        @media (max-width: 560px) {
          .sla-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};
